import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {RolesPermissionsListHeader} from './components/header/RolesPermissionsListHeader'
import {RolesPermissionsTable} from './table/RolesPermissionsTable'
import { RolePermissionEditModal } from './RolePermission-edit-modal/RolePermissionEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const RolesPermissionsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <RolesPermissionsListHeader />
        <RolesPermissionsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <RolePermissionEditModal />}
    </>
  )
}

const RolesPermissionsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <RolesPermissionsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {RolesPermissionsListWrapper}
